export const locales: { [locale: string]: () => Promise<any> } = {
  fr: () => import('../fr/fr'),
  en: () => import('../en/en'),
  bg: () => import('../_others/bg/bg'),
  cs: () => import('../_others/cs/cs'),
  da: () => import('../_others/da/da'),
  de: () => import('../_others/de/de'),
  el: () => import('../_others/el/el'),
  es: () => import('../_others/es/es'),
  hu: () => import('../_others/hu/hu'),
  it: () => import('../_others/it/it'),
  lt: () => import('../_others/lt/lt'),
  lv: () => import('../_others/lv/lv'),
  nl: () => import('../_others/nl/nl'),
  pl: () => import('../_others/pl/pl'),
  pt: () => import('../_others/pt/pt'),
  ro: () => import('../_others/ro/ro'),
  ru: () => import('../_others/ru/ru'),
  ar: () => import('../_others/ar/ar'),
};

export const localesDayjs: { [locale: string]: () => Promise<any> } = {
  fr: () => import('dayjs/locale/fr'),
  en: () => import('dayjs/locale/en'),
  bg: () => import('dayjs/locale/bg'),
  cs: () => import('dayjs/locale/cs'),
  da: () => import('dayjs/locale/da'),
  de: () => import('dayjs/locale/de'),
  el: () => import('dayjs/locale/el'),
  es: () => import('dayjs/locale/es'),
  hu: () => import('dayjs/locale/hu'),
  it: () => import('dayjs/locale/it'),
  lt: () => import('dayjs/locale/lt'),
  lv: () => import('dayjs/locale/lv'),
  nl: () => import('dayjs/locale/nl'),
  pl: () => import('dayjs/locale/pl'),
  pt: () => import('dayjs/locale/pt'),
  ro: () => import('dayjs/locale/ro'),
  ru: () => import('dayjs/locale/ru'),
  ar: () => import('dayjs/locale/ar'),
};
